<script>
  'use strict'
  import { _tilesCollections, _tilesCollectionFileName, _updateTileIdx } from "../store/store";
  
  export let idxToUpdate;
  // -------------------------------------------------

  // -------------------------------------------------

  async function onUpdateFile(event) {
    const file = event.target.files[0];
    let reader = new FileReader();
    reader.onload = function(e) {
      const imageFormatedInBase64 = e.target.result;
      const idx = $_updateTileIdx;

      let temptilesCollections = [...$_tilesCollections];
      temptilesCollections[idx] = imageFormatedInBase64;
      
      let tilesCollectionFileName = [...$_tilesCollectionFileName];
      tilesCollectionFileName[idx] = file.name;

      _tilesCollections.set(temptilesCollections);
      _tilesCollectionFileName.set(tilesCollectionFileName);
    };
    reader.readAsDataURL(file);
  }

  function updateTileIdx(idx) {
    _updateTileIdx.set(idx);
  }
</script>

<div>
  <input type="file" name="updateTile" id="updateTile" on:change="{onUpdateFile}" accept="image/*" hidden/>
  <label class="import-btn" for="updateTile" title="Update tile" on:click="{() => updateTileIdx(idxToUpdate)}">&#8645;</label>
</div>
